import { createContext, useContext, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNotification } from '../contexts/NotificationContext';

const ErrorContext = createContext({
    showError: (msg) => {},
});

export const useError = () => useContext(ErrorContext);

export const ErrorProvider = ({ children }) => {
    const { createErrorNotification } = useNotification();
    const showError = useCallback(
        (error = null, defaultMessage = null) => {
            const msg = error?.response?.data?.error ||
                        defaultMessage ||
                        'The action failed. Please try again later.';

            createErrorNotification(msg);
        },
        [createErrorNotification]
    );

    const contextValue = useMemo(() => ({ showError }), [showError]);

    return (
        <ErrorContext.Provider value={contextValue}>
            {children}
        </ErrorContext.Provider>
    );
};

ErrorProvider.propTypes = {
    children: PropTypes.node.isRequired
};